import {
  maskMobile,
  maskEmail,
} from "components/CommonComponents/CommonFunctions";
import React, { useEffect } from "react";
import { Button } from "reactstrap";

function OTPScreen({
  otpState,
  inputsRef,
  handlePaste,
  handleOtpChange,
  handleOtpKeyDown,
  resendOtp,
  enterdValue,
  showLoader,
  verifyOtp,
  identifierLabel = "mobile",
  showChangeIdentifier = false,
  onChangeIdentifier,
  btnName = "Verify OTP",
}) {
  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };
  
  useEffect(() => {
    if (inputsRef?.current?.length) {
      inputsRef.current[0]?.focus();
    }
  }, []);

  return (
    <>
      <div className="text-center mb-4">
        <p className="text-muted">
          Please enter the 6-digit OTP sent to your{" "}
          {identifierLabel === "email" ? "email address" : "mobile number"}
          <span className="text-deep-blue ml-1 mt--2">
            {identifierLabel === "email"
              ? maskEmail(enterdValue)
              : maskMobile(enterdValue)}
          </span>
        </p>
      </div>

      <div className="otp-box-row" onPaste={handlePaste}>
        {otpState.otp.map((digit, index) => (
          <input
            type="tel"
            inputMode="numeric"
            key={index}
            maxLength={1}
            ref={(el) => (inputsRef.current[index] = el)}
            value={digit}
            className={`otp-box ${otpState.error ? "otp-error" : ""}`}
            onChange={(e) => handleOtpChange(e.target.value, index)}
            onKeyDown={(e) => handleOtpKeyDown(e, index)}
          />
        ))}
      </div>

      {otpState.error && (
        <div className="invalid-feedback d-block">{otpState.error}</div>
      )}

      <div className="otp-action-row">
        <div className="otp-left">
          {showChangeIdentifier && (
            <button
              type="button"
              className="change-email-btn"
              onClick={onChangeIdentifier}
            >
              Change {identifierLabel === "email" ? "Email Address" : "Mobile Number"}
            </button>
          )}
        </div>

        <div className="otp-right">
          {otpState.timer > 0 ? (
            <span className="resend-text">
              Resend OTP in <b>{formatTime(otpState.timer)}</b>
            </span>
          ) : (
            <button className="resend-btn" onClick={resendOtp}>
              Resend OTP
            </button>
          )}
        </div>
      </div>

      <Button
        className="btn-vivid-red w-100 mt-3 mb-2 py-3 text-md"
        onClick={() => verifyOtp(otpState.otp)}
        disabled={showLoader.verifyOtp}
      >
        {showLoader.verifyOtp ? (
          <i className="fa fa-spinner fa-spin fa-xl text-white" />
        ) : (
          btnName
        )}
      </Button>
    </>
  );
}

export default OTPScreen;
